import React from "react";
import { useNavigate } from "react-router-dom";

export const Analytics = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="app-container [font-family:'Nunito',Helvetica] text-[#5d4037] pb-40">
        {/* Topbar */}
        <div className="w-full flex items-center mt-4">
          <button onClick={() => navigate(-1)} className="ml-4 w-9 h-9 rounded-full bg-[#ccb357] grid place-items-center" aria-label="Back">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
          </button>
          <h1 className="flex-1 text-center font-bold text-[18px]">Analytics</h1>
          <div className="w-9" />
        </div>

        {/* SALES REPORTING */}
        <div className="px-4 mt-4">
          <p className="font-extrabold uppercase text-[13px] tracking-wide">Sales Reporting</p>

          {/* fake dropdown */}
          <div className="mt-2 flex justify-end">
            <div className="px-3 h-[28px] rounded-[8px] bg-white border border-[#eadfb7] text-[12px] inline-flex items-center gap-2">
              Last Week
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>
            </div>
          </div>

          {/* bar chart */}
          <div className="mt-2 bg-[#fff8e1] border border-[#eadfb7] rounded-[12px] p-4">
            <div className="h-[140px] relative">
              {/* grid lines */}
              <div className="absolute inset-0 opacity-40">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="absolute left-0 right-0 border-t border-[#eadfb7]" style={{ top: `${(i+1)*20}%` }} />
                ))}
              </div>
              {/* bars */}
              <div className="absolute left-3 right-3 bottom-0 flex items-end justify-between">
                {[70, 110, 65, 30, 140, 50, 80].map((h, i) => (
                  <div key={i} className={`w-7 rounded-t ${i===3 ? "bg-[#e77]" : "bg-[#5d4037]"}`} style={{ height: `${h}px` }} />
                ))}
              </div>

              {/* tooltip chip */}
              <div className="absolute left-1/2 -translate-x-1/2 -top-3">
                <div className="px-2 py-0.5 rounded-full bg-[#5d4037] text-[#f7c945] text-[11px] shadow">★ ₦160,000</div>
              </div>
            </div>
            {/* x labels */}
            <div className="mt-2 flex justify-between text-[11px] text-[#5d4037]/80">
              {["1 Sep","2 Sep","3 Sep","4 Sep","5 Sep","6 Sep","7 Sep"].map((d)=>(<span key={d}>{d}</span>))}
            </div>
          </div>
        </div>

        {/* Overview section */}
        <div className="px-4 mt-5">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-extrabold">Overview</p>
              <p className="text-[12px] text-[#5d4037]/80 -mt-0.5">Compared to last week</p>
            </div>
            <button className="px-3 h-[30px] rounded-[16px] bg-[#f7c945] text-[12px] font-semibold">My products</button>
          </div>

          <div className="mt-3 grid grid-cols-2 gap-3">
            {[
              {t:"Revenue",v:"₦ 200k",pct:"13%"},
              {t:"Sales",v:"₦ 15k",pct:"6%"},
              {t:"Customers",v:"21",pct:"15%"},
              {t:"Orders",v:"1k",pct:"12%"},
            ].map((c,i)=>(
              <div key={i} className="rounded-[12px] bg-white border border-[#eadfb7] p-3">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    <div className="w-4 h-4 rounded-full bg-[#f7c945]" />
                    <p className="font-bold text-[14px]">{c.t}</p>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><path d="M7 17L17 7M7 7h10v10"/></svg>
                </div>
                <p className="mt-2 font-extrabold">{c.v}</p>
                <p className="text-[12px] text-[#5d4037]/80 mt-1">{c.pct}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Top Products list */}
        <div className="px-4 mt-6">
          <p className="font-extrabold">Top Products</p>
          <div className="mt-3 space-y-3">
            {[
              { name:"Pizza with coke", price:"₦12,000", sold:15, img:"https://images.unsplash.com/photo-1548365328-9f547fb0959f?w=200&q=80&auto=format&fit=crop"},
              { name:"Banana cake", price:"₦12,000", sold:12, img:"https://images.unsplash.com/photo-1605470207062-1be28f5f2c65?w=200&q=80&auto=format&fit=crop"},
              { name:"French fries", price:"₦12,000", sold:11, img:"https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=200&q=80&auto=format&fit=crop"},
            ].map((p,i)=>(
              <div key={i} className="rounded-[10px] bg-[#ede6c9] px-2 py-2 flex items-center">
                <img alt="" src={p.img} className="w-12 h-12 rounded-[8px] object-cover"/>
                <div className="ml-3">
                  <p className="font-bold text-[14px]">{p.name}</p>
                  <p className="text-[12px]">{p.price}</p>
                </div>
                <div className="ml-auto text-right pr-1">
                  <p className="font-bold">{p.sold}</p>
                  <p className="text-[12px]">Sold</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Brown bar */}
        <div className="fixed bottom-3 md:bottom-6 left-1/2 -translate-x-1/2 w-full max-w-[1440px] xl:max-w-[1600px] px-6 md:px-10 xl:px-16">
          <div className="h-[22px] bg-[#5d4037] flex items-center justify-center">
            <div className="w-[120px] h-[6px] rounded-full bg-white" />
          </div>
        </div>
      </div>
    </div>
  );
};
